export type RetailerRoutes = {
  '': '/';
  newyear25: '/NEWYEAR25';
  about: '/about';
  adyenLinkingActionResult: '/adyen-linking-action-result';
  affiliates: '/affiliates';
  allBrands: '/all-brands';
  allMakers: '/all-makers';
  amex: '/amex';
  aoda: '/aoda';
  apparelCollectionproductBasedCollectionToken: '/apparel-collection/:productBasedCollectionToken([^/]+)';
  apply: '/apply';
  applyAd: '/apply/ad';
  applyMarkets: '/apply/markets';
  applyRretailerTokenSuffix: '/apply/r/:retailerTokenSuffix';
  applybrandTokenOrAlias: '/apply/:brandTokenOrAlias';
  applyChildren: '/apply:children(/?.*)';
  assortmentassortmentToken: '/assortment/:assortmentToken';
  atl: '/atl';
  atlantaMarket: '/atlanta-market';
  atlantamarket: '/atlantamarket';
  autumnFair: '/autumn-fair';
  bestseller: '/bestseller';
  blog: '/blog';
  blogcategory: '/blog/:category([^/]*)';
  blogcategoryarticle: '/blog/:category([^/]*)/:article([^/]*)';
  boards: '/boards';
  boardsFollowing: '/boards/following';
  boardsretailerBoardToken: '/boards/:retailerBoardToken';
  boardsChildren: '/boards:children(/?.*)';
  brandInvoicebrandInvoiceToken: '/brand-invoice/:brandInvoiceToken([^/]*)';
  brandOrderbrandOrderToken: '/brand-order/:brandOrderToken';
  brandOrderbrandOrderTokenDutiesRefund: '/brand-order/:brandOrderToken/duties-refund';
  brandOrderbrandOrderTokenDutiesRefundFurtherReview: '/brand-order/:brandOrderToken/duties-refund/further-review';
  brandOrderbrandOrderTokenDutiesRefundSuccess: '/brand-order/:brandOrderToken/duties-refund/success';
  brandOrderbrandOrderTokenchildren: '/brand-order/:brandOrderToken/:children(/?.*)';
  brandbrandToken: '/brand/:brandToken([^/]*)';
  brandbrandTokenpage: '/brand/:brandToken([^/]*)/:page(\d+)';
  brandbrandTokenChildren: '/brand/:brandToken([^/]*):children(/?.*)';
  brandbrandTokenBrandOrderSelectForReview: '/brand/:brandToken/brand-order/select-for-review';
  brandbrandTokenBuyItAgain: '/brand/:brandToken/buy-it-again';
  brandbrandTokenNewProducts: '/brand/:brandToken/new-products';
  brandbrandTokenProductBundlebundleIdentifier: '/brand/:brandToken/product-bundle/:bundleIdentifier';
  brandbrandTokenVideos: '/brand/:brandToken/videos';
  brands: '/brands';
  brandsApp: '/brands/app';
  brandsCategory: '/brands/category';
  brandsCreateAccount: '/brands/create-account';
  brandsDirect: '/brands/direct';
  brandsFwm: '/brands/fwm';
  brandsNonFwm: '/brands/non-fwm';
  brandsPersonalized: '/brands/personalized';
  brandsPricing: '/brands/pricing';
  brandsReferralOfferbrandLeadReferralBonusOfferToken: '/brands/referral-offer/:brandLeadReferralBonusOfferToken';
  brandsReferralbrandLeadReferralToken: '/brands/referral/:brandLeadReferralToken';
  brandsbrandToken: '/brands/:brandToken';
  builder: '/builder';
  builderTesting: '/builder-testing';
  builderEditSymbols: '/builder/edit-symbols';
  builderpageName: '/builder/:pageName([^/]*)';
  careers: '/careers';
  careersBelongingAtFaire: '/careers/belonging-at-faire';
  careersFlexibleWorkPolicy: '/careers/flexible-work-policy';
  careersOpenings: '/careers/openings';
  caresAct: '/cares-act';
  cart: '/cart';
  cartbrandToken: '/cart/:brandToken([^/]*)';
  categoryDrops: '/category/Drops';
  categoryShowroom: '/category/Showroom';
  categoryc1CategoryUrlId: '/category/:c1CategoryUrlId';
  categoryc1CategoryUrlIdAttributeattributeNameattributeValue: '/category/:c1CategoryUrlId/attribute/:attributeName/:attributeValue';
  categoryc1CategoryUrlIdBrandValuebrandValue: '/category/:c1CategoryUrlId/brand-value/:brandValue';
  categoryc1CategoryUrlIdLoccountryregion: '/category/:c1CategoryUrlId/loc/:country/:region';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlId: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdAttributeattributeNameattributeValue: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/attribute/:attributeName/:attributeValue';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdBrandValuebrandValue: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/brand-value/:brandValue';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdLoccountryregion: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/loc/:country/:region';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdc3CategoryUrlId: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdc3CategoryUrlIdAttributeattributeNameattributeValue: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/attribute/:attributeName/:attributeValue';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdc3CategoryUrlIdBrandValuebrandValue: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/brand-value/:brandValue';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdc3CategoryUrlIdLoccountryregion: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/loc/:country/:region';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdc3CategoryUrlIdc4CategoryUrlId: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdc3CategoryUrlIdc4CategoryUrlIdc5CategoryUrlId: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId/:c5CategoryUrlId';
  categoryc1CategoryUrlIdSubcategoryc2CategoryUrlIdc3CategoryUrlIdc4CategoryUrlIdc5CategoryUrlIdc6CategoryUrlId: '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId/:c5CategoryUrlId/:c6CategoryUrlId';
  checkout: '/checkout';
  checkoutBusinessInfo: '/checkout/business-info';
  checkoutPaymentInfo: '/checkout/payment-info';
  checkoutPaymentTerms: '/checkout/payment-terms';
  checkoutSelectPayment: '/checkout/select-payment';
  checkoutShippingAddress: '/checkout/shipping-address';
  checkoutShippingAddressNew: '/checkout/shipping-address/new';
  checkoutShippingMethods: '/checkout/shipping-methods';
  checkoutSignup: '/checkout/signup';
  checkoutSuccessorderToken: '/checkout/success/:orderToken';
  checkoutVerificationorderToken: '/checkout/verification/:orderToken';
  checkoutChildren: '/checkout:children(/?.*)';
  communityStandards: '/community-standards';
  confirmIdentity: '/confirm-identity';
  confirmIdentityAddress: '/confirm-identity/address';
  confirmIdentityBusinessBank: '/confirm-identity/business-bank';
  confirmIdentityBusinessNames: '/confirm-identity/business-names';
  confirmIdentityComplete: '/confirm-identity/complete';
  confirmIdentityDescribeBusiness: '/confirm-identity/describe-business';
  confirmIdentityFreeFormstepId: '/confirm-identity/free-form/:stepId';
  confirmIdentityMultipleAccounts: '/confirm-identity/multiple-accounts';
  confirmIdentityOnlineDetails: '/confirm-identity/online-details';
  confirmIdentityProductUsage: '/confirm-identity/product-usage';
  confirmIdentityReadyToSell: '/confirm-identity/ready-to-sell';
  confirmIdentityResaleTaxId: '/confirm-identity/resale-tax-id';
  confirmIdentitySignSubmit: '/confirm-identity/sign-submit';
  confirmIdentityStorePhotos: '/confirm-identity/store-photos';
  confirmIdentityThirdPartyExclusivity: '/confirm-identity/third-party-exclusivity';
  confirmIdentityVerificationMethod: '/confirm-identity/verification-method';
  confirmLocalSso: '/confirm-local-sso';
  copyright: '/copyright';
  copyrightChildren: '/copyright:children(/?.*)';
  creditReportUse: '/credit-report-use';
  deactivateRinvitationToken: '/deactivate/r/:invitationToken';
  deactivateRinvitationTokenConfirmDeactivation: '/deactivate/r/:invitationToken/confirm-deactivation';
  deactivateRinvitationTokenVerifyIdentity: '/deactivate/r/:invitationToken/verify-identity';
  directMail1: '/direct-mail1';
  directbrandAlias: '/direct/:brandAlias';
  directbrandAliasRepsalesRepCode: '/direct/:brandAlias/rep/:salesRepCode';
  directbrandTokenOrAliasProductBasedCollectionproductBasedCollectionToken: '/direct/:brandTokenOrAlias/product-based-collection/:productBasedCollectionToken';
  directbrandTokenOrAliasProductproductToken: '/direct/:brandTokenOrAlias/product/:productToken([^/]*)';
  discoversearchTerm: '/discover/:searchTerm([^/]*)';
  empty: '/empty';
  exclusivity: '/exclusivity';
  exclusivityAllBrands: '/exclusivity/all-brands';
  expandingBusinessesOffer: '/expanding-businesses-offer';
  expandingBusinessesOfferApply: '/expanding-businesses-offer/apply';
  expiredLink: '/expired-link';
  exploresearchTerm: '/explore/:searchTerm([^/]*)';
  expo: '/expo';
  extensionSecret: '/extension-secret';
  faireContentfaireContentTokenOrAlias: '/faire-content/:faireContentTokenOrAlias';
  faireEventfaireContentTokenOrAlias: '/faire-event/:faireContentTokenOrAlias';
  faireForecast2025: '/faire-forecast-2025';
  fairePay: '/faire-pay';
  fairePayMobilePreEnroll: '/faire-pay/mobile-pre-enroll';
  fairePaySetup: '/faire-pay/setup';
  faireWebinarfaireContentTokenOrAlias: '/faire-webinar/:faireContentTokenOrAlias';
  fancyFood: '/fancy-food';
  fbfexhibits: '/fbfexhibits';
  featured: '/featured';
  featuredWholesaleGifts: '/featured/wholesale-gifts';
  flashSale: '/flash-sale';
  flashSaleflashSaleToken: '/flash-sale/:flashSaleToken([^/]*)';
  forecast: '/forecast';
  getStarted: '/get-started';
  grandPrix: '/grand-prix';
  guaranteedfairtrade: '/guaranteedfairtrade';
  harrogate: '/harrogate';
  imprint: '/imprint';
  insider: '/insider';
  insiderTermsAndConditions: '/insider/terms-and-conditions';
  insights: '/insights';
  jobs: '/jobs';
  lppageName: '/lp/:pageName([^/]*)';
  mpageName: '/m/:pageName([^/]*)';
  magic: '/magic';
  magiclv: '/magiclv';
  makerbrandToken: '/maker/:brandToken([^/]*)';
  makers: '/makers';
  markets: '/markets';
  marketsAllSpecials: '/markets/all-specials';
  marketsAllSpecialsMyMarketList: '/markets/all-specials/my-market-list';
  marketsBrandDirectoryeventType: '/markets/brand-directory/:eventType';
  marketsSpecialsAZ: '/markets/specials-a-z';
  marketseventType: '/markets/:eventType';
  marketseventTypeAllSpecials: '/markets/:eventType/all-specials';
  marketseventTypeAllSpecialsMyMarketList: '/markets/:eventType/all-specials/my-market-list';
  marketsChildren: '/markets:children(/?.*)';
  merchandisedCollectionmcVanityUrl: '/merchandised-collection/:mcVanityUrl([^/]*)';
  merchandisedCollectionChildren: '/merchandised-collection:children(/?.*)';
  mergemergeIdentifier: '/merge/:mergeIdentifier';
  messages: '/messages';
  messagesotherPartyToken: '/messages/:otherPartyToken';
  messagesChildren: '/messages:children(/?.*)';
  milestones: '/milestones';
  myBrands: '/my-brands';
  myBrandsNowOnFaire: '/my-brands/now-on-faire';
  myBrandsNowOnFaireFindBrands: '/my-brands/now-on-faire/find-brands';
  myBrandsUpdates: '/my-brands/updates';
  myReviews: '/my-reviews';
  myReviewsBrandOrderbrandOrderToken: '/my-reviews/brand-order/:brandOrderToken';
  myReviewsBrandOrderbrandOrderTokenProducts: '/my-reviews/brand-order/:brandOrderToken/products';
  myReviewsBrandOrderbrandOrderTokenProductsproductToken: '/my-reviews/brand-order/:brandOrderToken/products/:productToken';
  myReviewsBrandbrandToken: '/my-reviews/brand/:brandToken';
  myReviewsCompleted: '/my-reviews/completed';
  natexpo25: '/natexpo25';
  netTerms: '/net-terms';
  netTermsApply: '/net-terms/apply';
  netTermsIncreaseLimit: '/net-terms/increase-limit';
  netTermsOwfApplication: '/net-terms/owf-application';
  netTermsSuccess: '/net-terms/success';
  netTermsChildren: '/net-terms:children(/?.*)';
  newBrandFinder: '/new-brand-finder';
  newBrandFinderresultToken: '/new-brand-finder/:resultToken';
  news: '/news';
  newsAbout: '/news/about';
  newsCaseStudies: '/news/case-studies';
  newsMedia: '/news/media';
  newsarticleToken: '/news/:articleToken([^/]*)';
  nextjsStreamingTest: '/nextjs-streaming-test';
  onboard: '/onboard';
  onfirmIdentityThirdPartyExclusivity: '/onfirm-identity/third-party-exclusivity';
  open: '/open';
  openWithFaire: '/open-with-faire';
  openWithFaireAdditionalInfo: '/open-with-faire-additional-info';
  openWithFaireAcademy: '/open-with-faire/academy';
  openWithFaireAcademyBuyRetailInventory: '/open-with-faire/academy/buy-retail-inventory';
  openWithFaireAcademyFindRetailSpace: '/open-with-faire/academy/find-retail-space';
  openWithFaireAcademyFundingLicensing: '/open-with-faire/academy/funding-licensing';
  openWithFaireAcademyLayTheGroundwork: '/open-with-faire/academy/lay-the-groundwork';
  openWithFaireAcademyOrganizeStoreOperations: '/open-with-faire/academy/organize-store-operations';
  openWithFaireAcademyPromoteYourStore: '/open-with-faire/academy/promote-your-store';
  openWithFaireAcademyRenovateYourStore: '/open-with-faire/academy/renovate-your-store';
  openWithFaireChildren: '/open-with-faire:children(/?.*)';
  openChildren: '/open:children(/?.*)';
  orderInsights: '/order-insights';
  orderInsightsresultToken: '/order-insights/:resultToken';
  orders: '/orders';
  ordersorderTokenbrandToken: '/orders/:orderToken/:brandToken';
  owf: '/owf';
  owfChildren: '/owf:children(/?.*)';
  partnerCollectionmcVanityUrl: '/partner-collection/:mcVanityUrl([^/]*)';
  partnerships: '/partnerships';
  pgl: '/pgl';
  plaidOauthResult: '/plaid-oauth-result';
  pointOfSale: '/point-of-sale';
  pointOfSaleAbout: '/point-of-sale/about';
  pointOfSaleArchived: '/point-of-sale/archived';
  pointOfSaleConnectCloverApp: '/point-of-sale/connect-clover-app';
  pointOfSaleConnectShopifyApp: '/point-of-sale/connect-shopify-app';
  pointOfSaleConnectSquareApp: '/point-of-sale/connect-square-app';
  pointOfSaleConsent: '/point-of-sale/consent';
  pointOfSaleItemproductOptionToken: '/point-of-sale/item/:productOptionToken';
  pointOfSaleItemproductOptionTokenEdit: '/point-of-sale/item/:productOptionToken/edit';
  pointOfSaleItems: '/point-of-sale/items';
  pointOfSaleLinked: '/point-of-sale/linked';
  pointOfSaleMatches: '/point-of-sale/matches';
  pointOfSaleOnboarding: '/point-of-sale/onboarding';
  pointOfSaleOrderManagerorderToken: '/point-of-sale/order-manager/:orderToken';
  pointOfSaleOrders: '/point-of-sale/orders';
  pointOfSaleOrdersbrandOrderToken: '/point-of-sale/orders/:brandOrderToken';
  pointOfSaleOrdersorderTokenbrandToken: '/point-of-sale/orders/:orderToken/:brandToken';
  pointOfSaleSettings: '/point-of-sale/settings';
  pointOfSaleUnlinked: '/point-of-sale/unlinked';
  popular: '/popular';
  press: '/press';
  prestashop: '/prestashop';
  privacy: '/privacy';
  privacyDisclosure: '/privacy-disclosure';
  privacyUs: '/privacy-us';
  privacyCookies: '/privacy/cookies';
  privacyChildren: '/privacy:children(/?.*)';
  productBasedCollectionproductBasedCollectionToken: '/product-based-collection/:productBasedCollectionToken';
  productproductToken: '/product/:productToken([^/]*)';
  productproductTokenChildren: '/product/:productToken([^/]*):children(/?.*)';
  productproductTokenAddedToCart: '/product/:productToken/added-to-cart';
  recommendationBrands: '/recommendation/brands';
  recommendationProducts: '/recommendation/products';
  rejectBrandEmailVerificationemailVerificationRequestToken: '/reject-brand-email-verification/:emailVerificationRequestToken';
  rejectBrandIdvRequestidvRequestToken: '/reject-brand-idv-request/:idvRequestToken';
  reorder: '/reorder';
  repsalesRepCode: '/rep/:salesRepCode';
  retailerPos: '/retailer/pos';
  retailerPosItems: '/retailer/pos/items';
  retailerPosItemsproductOptionToken: '/retailer/pos/items/:productOptionToken';
  retailerPosMatching: '/retailer/pos/matching';
  retailerSettings: '/retailer/settings';
  retailerSettingsAccount: '/retailer/settings/account';
  retailerSettingsAvailableCredit: '/retailer/settings/available-credit';
  retailerSettingsDeactivateAccount: '/retailer/settings/deactivate-account';
  retailerSettingsEmailPreferences: '/retailer/settings/email-preferences';
  retailerSettingsInsiderMembership: '/retailer/settings/insider-membership';
  retailerSettingsInsiderMembershipCancellation: '/retailer/settings/insider-membership/cancellation';
  retailerSettingsMyAddresses: '/retailer/settings/my-addresses';
  retailerSettingsMyTeam: '/retailer/settings/my-team';
  retailerSettingsMyTeamPermissionsuserToken: '/retailer/settings/my-team/permissions/:userToken';
  retailerSettingsOnboard: '/retailer/settings/onboard';
  retailerSettingsPaymentMethods: '/retailer/settings/payment-methods';
  retailerSettingsPosManager: '/retailer/settings/pos-manager';
  retailerSettingsProfile: '/retailer/settings/profile';
  retailerSettingsSecurity: '/retailer/settings/security';
  retailerSettingsSecurityAccountActivity: '/retailer/settings/security/account-activity';
  retailerSettingsShippingPreferences: '/retailer/settings/shipping-preferences';
  retailerSettingsStores: '/retailer/settings/stores';
  retailerSettingsStoresNew: '/retailer/settings/stores/new';
  retailerSettingsStoresstoreToken: '/retailer/settings/stores/:storeToken';
  retailerretailerToken: '/retailer/:retailerToken';
  retailerretailerTokenBrandOrderbrandOrderTokenReview: '/retailer/:retailerToken/brand-order/:brandOrderToken/review';
  retailerretailerTokenBrandbrandToken: '/retailer/:retailerToken/brand/:brandToken([^/]*)';
  retailerretailerTokenBrandbrandTokenChildren: '/retailer/:retailerToken/brand/:brandToken([^/]*):children(/?.*)';
  retailerretailerTokenBrandbrandTokenBrandOrderSelectForReview: '/retailer/:retailerToken/brand/:brandToken/brand-order/select-for-review';
  retailerretailerTokenCart: '/retailer/:retailerToken/cart';
  retailerretailerTokenCategoryc1CategorySubcategoryc2Categoryc3Category: '/retailer/:retailerToken/category/:c1Category([^/]*)/subcategory/:c2Category([^/]*)/:c3Category([^/]*)';
  retailerretailerTokenCategorycategoryName: '/retailer/:retailerToken/category/:categoryName([^/]*)';
  retailerretailerTokenCategorycategoryNameSubcategorysubcategoryName: '/retailer/:retailerToken/category/:categoryName([^/]*)/subcategory/:subcategoryName([^/]*)';
  retailerretailerTokenConfirmIdentity: '/retailer/:retailerToken/confirm-identity';
  retailerretailerTokenDiscover: '/retailer/:retailerToken/discover';
  retailerretailerTokenDiscoverChildren: '/retailer/:retailerToken/discover:children(/?.*)';
  retailerretailerTokenFlashSale: '/retailer/:retailerToken/flash-sale';
  retailerretailerTokenFlashSaleflashSaleToken: '/retailer/:retailerToken/flash-sale/:flashSaleToken([^/]*)';
  retailerretailerTokenLimit: '/retailer/:retailerToken/limit';
  retailerretailerTokenMyBrands: '/retailer/:retailerToken/my-brands';
  retailerretailerTokenNetTermsChildren: '/retailer/:retailerToken/net-terms:children(/?.*)';
  retailerretailerTokenReorder: '/retailer/:retailerToken/reorder';
  retailerretailerTokenRetailerProductRecommendations: '/retailer/:retailerToken/retailer-product-recommendations';
  retailerretailerTokenReviews: '/retailer/:retailerToken/reviews';
  retailerretailerTokenSearch: '/retailer/:retailerToken/search';
  sampleWithFoodAndBeverage: '/sample-with-food-and-beverage';
  sampleinviteToken: '/sample/:inviteToken';
  sduiVisualizer: '/sdui-visualizer';
  search: '/search';
  searchChildren: '/search:children(/?.*)';
  seeMore: '/see-more';
  shopTheStories: '/shop-the-stories';
  signUpSocial: '/sign-up/social';
  siteMap: '/site-map';
  sitemapXmlGz: '/sitemap.xml.gz';
  sitewideOffer: '/sitewide-offer';
  smallBusinessGrant: '/small-business-grant';
  smallBusinessGrantApply: '/small-business-grant/apply';
  smallBusinessGrantTos: '/small-business-grant/tos';
  springFair: '/spring-fair';
  squareHome: '/square-home';
  squareHomeChildren: '/square-home:children(/?.*)';
  standAgainstBland: '/stand-against-bland';
  summerMarket: '/summer-market';
  summerMarket2021: '/summer-market-2021';
  summerMarket2021Children: '/summer-market-2021:children(/?.*)';
  summerMarketChildren: '/summer-market:children(/?.*)';
  suppliersc1SuppliersUrlId: '/suppliers/:c1SuppliersUrlId';
  suppliersc1SuppliersUrlIdBrandValuebrandValue: '/suppliers/:c1SuppliersUrlId/brand-value/:brandValue';
  suppliersc1SuppliersUrlIdSubcategoryc2SuppliersUrlId: '/suppliers/:c1SuppliersUrlId/subcategory/:c2SuppliersUrlId';
  suppliersc1SuppliersUrlIdSubcategoryc2SuppliersUrlIdc3SuppliersUrlId: '/suppliers/:c1SuppliersUrlId/subcategory/:c2SuppliersUrlId/:c3SuppliersUrlId';
  team: '/team';
  tools: '/tools';
  toolstoolName: '/tools/:toolName([^/]*)';
  tos: '/tos';
  tosBrand: '/tos-brand';
  tosBrandJuly5: '/tos-brand-july5';
  tosFairePay: '/tos-faire-pay';
  tosInsider: '/tos-insider';
  tosProductGuidelines: '/tos-product-guidelines';
  tosPurchaseOrder: '/tos-purchase-order';
  tosReacceptance: '/tos-reacceptance';
  tosRetailer: '/tos-retailer';
  tosReturnsGuidelines: '/tos-returns-guidelines';
  tosMaker: '/tos_maker';
  tosChildren: '/tos:children(/?.*)';
  trendingOnFaire: '/trending-on-faire';
  trendset: '/trendset';
  underwritingInformation: '/underwriting-information';
  unrecognizedLoginNotification: '/unrecognized-login-notification';
  unsubscribe: '/unsubscribe';
  unsubscribeFromBrand: '/unsubscribe-from-brand';
  user: '/user';
  userAccount: '/user/account';
  userAccountInvoices: '/user/account/invoices';
  userAccountInvoicesPaid: '/user/account/invoices/paid';
  userAccountInvoicesPaymentPlan: '/user/account/invoices/payment-plan';
  userAccountInvoicesUnpaid: '/user/account/invoices/unpaid';
  userAccountInvoicesinvoiceToken: '/user/account/invoices/:invoiceToken([^/]*)';
  userAccountNewPaymentPlan: '/user/account/new-payment-plan';
  userAccountOrders: '/user/account/orders';
  userAccountOrdersBrandInvoicesbrandInvoiceToken: '/user/account/orders/brandInvoices/:brandInvoiceToken';
  userAccountOrdersCompleted: '/user/account/orders/completed';
  userAccountOrdersPending: '/user/account/orders/pending';
  userAccountOrdersPurchaseOrdersCreate: '/user/account/orders/purchase-orders/create';
  userAccountOrdersPurchaseOrdersCreatepurchaseOrderToken: '/user/account/orders/purchase-orders/create/:purchaseOrderToken';
  userAccountOrdersPurchaseOrdersLandingPage: '/user/account/orders/purchase-orders/landing-page';
  userAccountOrdersPurchaseOrderspurchaseOrderTokenSuccess: '/user/account/orders/purchase-orders/:purchaseOrderToken/success';
  userAccountOrdersPurchaseOrderpurchaseOrderToken: '/user/account/orders/purchase_order/:purchaseOrderToken';
  userAccountOrdersorderTokenbrandToken: '/user/account/orders/:orderToken([^/]*)/:brandToken([^/]*)';
  userAccountOrdersorderTokenbrandOrderTokenReturnHistory: '/user/account/orders/:orderToken/:brandOrderToken/return-history';
  userAccountOrdersorderTokenbrandTokenReport: '/user/account/orders/:orderToken/:brandToken/report';
  userAccountOrdersorderTokenbrandTokenReturn: '/user/account/orders/:orderToken/:brandToken/return';
  userAccountOrdersChildren: '/user/account/orders:children(/?.*)';
  userAccountPaymentAssistance: '/user/account/payment-assistance';
  userAccountPaymentPlan: '/user/account/payment-plan';
  userAccountReturnsreturnOrderToken: '/user/account/returns/:returnOrderToken';
  userAccountSamplessampleRequestToken: '/user/account/samples/:sampleRequestToken';
  userBrandReferrals: '/user/brand-referrals';
  userBrandReferralsPreviewReferralEmail: '/user/brand-referrals/preview-referral-email';
  userBrandReferralsChildren: '/user/brand-referrals:children(/?.*)';
  userEditOrderbrandOrderToken: '/user/edit-order/:brandOrderToken';
  userEditOrderbrandOrderTokenSuccess: '/user/edit-order/:brandOrderToken/success';
  userInsiderCancel: '/user/insider/cancel';
  userInsiderInfo: '/user/insider/info';
  userInsiderPause: '/user/insider/pause';
  userInsiderSuccess: '/user/insider/success';
  userLinkPosorderTokenSuccess: '/user/link-pos/:orderToken/success';
  userMakerReferrals: '/user/maker-referrals';
  userMakerReferralsPreviewReferralEmail: '/user/maker-referrals/preview-referral-email';
  userMakerReferralsChildren: '/user/maker-referrals:children(/?.*)';
  userMobileAccountPage: '/user/mobile-account-page';
  userNotifications: '/user/notifications';
  userPaymentAssistanceApplication: '/user/payment-assistance-application';
  userRetailerReferrals: '/user/retailer-referrals';
  userSignUp: '/user/sign-up';
  userStyleQuiz: '/user/style-quiz';
  userTradeShowSignUpbrandInvoiceToken: '/user/trade-show-sign-up/:brandInvoiceToken';
  userChildren: '/user:children(/?.*)';
  videovideoToken: '/video/:videoToken([^/]*)';
  volumePricing: '/volume-pricing';
  welcome: '/welcome';
  welcomeBPersonal: '/welcome/b/personal';
  welcomeR: '/welcome/r';
  welcomeRAnnualSales: '/welcome/r/annual-sales';
  welcomeRBookACall: '/welcome/r/book-a-call';
  welcomeRBrandRelationshipSurvey: '/welcome/r/brand-relationship-survey';
  welcomeRBusinessType: '/welcome/r/business-type';
  welcomeRBusinessUse: '/welcome/r/business-use';
  welcomeRCalculateTermLimit: '/welcome/r/calculate-term-limit';
  welcomeRCollectBrands: '/welcome/r/collect-brands';
  welcomeRCombinedOpenWithFaireAccount: '/welcome/r/combined-open-with-faire/account';
  welcomeRCombinedOpenWithFaireApplication: '/welcome/r/combined-open-with-faire/application';
  welcomeRCombinedOpenWithFaireIneligible: '/welcome/r/combined-open-with-faire/ineligible';
  welcomeRCombinedOpenWithFaireStartShopping: '/welcome/r/combined-open-with-faire/start-shopping';
  welcomeRComplete: '/welcome/r/complete';
  welcomeRConnectEmail: '/welcome/r/connect-email';
  welcomeRConsumer: '/welcome/r/consumer';
  welcomeRDescribeStore: '/welcome/r/describe-store';
  welcomeRLegalBusinessName: '/welcome/r/legal-business-name';
  welcomeRNetTermStartShopping: '/welcome/r/net-term-start-shopping';
  welcomeRNetTermUnlocked: '/welcome/r/net-term-unlocked';
  welcomeRNetTerms: '/welcome/r/net-terms';
  welcomeRNotifyMe: '/welcome/r/notify-me';
  welcomeRNotifyMeSuccess: '/welcome/r/notify-me/success';
  welcomeROpenWithFaireApplication: '/welcome/r/open-with-faire/application';
  welcomeROpenWithFaireIntro: '/welcome/r/open-with-faire/intro';
  welcomeROpenWithFaireNonBm: '/welcome/r/open-with-faire/non-bm';
  welcomeROpenWithFaireStartShopping: '/welcome/r/open-with-faire/start-shopping';
  welcomeROpenWithFaireSuccess: '/welcome/r/open-with-faire/success';
  welcomeROpeningMonth: '/welcome/r/opening-month';
  welcomeROpeningYear: '/welcome/r/opening-year';
  welcomeRPersonal: '/welcome/r/personal';
  welcomeRPhysicalStoreNumber: '/welcome/r/physical-store-number';
  welcomeRResaleIdentification: '/welcome/r/resale-identification';
  welcomeRResellerCert: '/welcome/r/reseller-cert';
  welcomeRSccDetails: '/welcome/r/scc-details';
  welcomeRSccPaymentTerms: '/welcome/r/scc-payment-terms';
  welcomeRSccTermsAgreement: '/welcome/r/scc-terms-agreement';
  welcomeRSelectCategories: '/welcome/r/select-categories';
  welcomeRSelectPaymentTerms: '/welcome/r/select-payment-terms';
  welcomeRSelectProducts: '/welcome/r/select-products';
  welcomeRSocialMedia: '/welcome/r/social-media';
  welcomeRStoreAttribution: '/welcome/r/store-attribution';
  welcomeRStoreDetails: '/welcome/r/store-details';
  welcomeRStoreInfo: '/welcome/r/store-info';
  welcomeRStoreTypeS1: '/welcome/r/store-type-s1';
  welcomeRStoreTypeS2: '/welcome/r/store-type-s2';
  welcomeRStoreValues: '/welcome/r/store-values';
  welcomeRSuccess: '/welcome/r/success';
  welcomeRType: '/welcome/r/type';
  welcomeChildren: '/welcome:children(/?.*)';
  whatsNext: '/whats-next';
  winterMarket2021: '/winter-market-2021';
  winterMarket2021Children: '/winter-market-2021:children(/?.*)';
  yearInReview: '/year-in-review';
};

export const retailerRoutes = [
  '/',
  '/NEWYEAR25',
  '/about',
  '/adyen-linking-action-result',
  '/affiliates',
  '/all-brands',
  '/all-makers',
  '/amex',
  '/aoda',
  '/apparel-collection/:productBasedCollectionToken([^/]+)',
  '/apply',
  '/apply/ad',
  '/apply/markets',
  '/apply/r/:retailerTokenSuffix',
  '/apply/:brandTokenOrAlias',
  '/apply:children(/?.*)',
  '/assortment/:assortmentToken',
  '/atl',
  '/atlanta-market',
  '/atlantamarket',
  '/autumn-fair',
  '/bestseller',
  '/blog',
  '/blog/:category([^/]*)',
  '/blog/:category([^/]*)/:article([^/]*)',
  '/boards',
  '/boards/following',
  '/boards/:retailerBoardToken',
  '/boards:children(/?.*)',
  '/brand-invoice/:brandInvoiceToken([^/]*)',
  '/brand-order/:brandOrderToken',
  '/brand-order/:brandOrderToken/duties-refund',
  '/brand-order/:brandOrderToken/duties-refund/further-review',
  '/brand-order/:brandOrderToken/duties-refund/success',
  '/brand-order/:brandOrderToken/:children(/?.*)',
  '/brand/:brandToken([^/]*)',
  '/brand/:brandToken([^/]*)/:page(\d+)',
  '/brand/:brandToken([^/]*):children(/?.*)',
  '/brand/:brandToken/brand-order/select-for-review',
  '/brand/:brandToken/buy-it-again',
  '/brand/:brandToken/new-products',
  '/brand/:brandToken/product-bundle/:bundleIdentifier',
  '/brand/:brandToken/videos',
  '/brands',
  '/brands/app',
  '/brands/category',
  '/brands/create-account',
  '/brands/direct',
  '/brands/fwm',
  '/brands/non-fwm',
  '/brands/personalized',
  '/brands/pricing',
  '/brands/referral-offer/:brandLeadReferralBonusOfferToken',
  '/brands/referral/:brandLeadReferralToken',
  '/brands/:brandToken',
  '/builder',
  '/builder-testing',
  '/builder/edit-symbols',
  '/builder/:pageName([^/]*)',
  '/careers',
  '/careers/belonging-at-faire',
  '/careers/flexible-work-policy',
  '/careers/openings',
  '/cares-act',
  '/cart',
  '/cart/:brandToken([^/]*)',
  '/category/Drops',
  '/category/Showroom',
  '/category/:c1CategoryUrlId',
  '/category/:c1CategoryUrlId/attribute/:attributeName/:attributeValue',
  '/category/:c1CategoryUrlId/brand-value/:brandValue',
  '/category/:c1CategoryUrlId/loc/:country/:region',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/attribute/:attributeName/:attributeValue',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/brand-value/:brandValue',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/loc/:country/:region',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/attribute/:attributeName/:attributeValue',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/brand-value/:brandValue',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/loc/:country/:region',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId/:c5CategoryUrlId',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId/:c5CategoryUrlId/:c6CategoryUrlId',
  '/checkout',
  '/checkout/business-info',
  '/checkout/payment-info',
  '/checkout/payment-terms',
  '/checkout/select-payment',
  '/checkout/shipping-address',
  '/checkout/shipping-address/new',
  '/checkout/shipping-methods',
  '/checkout/signup',
  '/checkout/success/:orderToken',
  '/checkout/verification/:orderToken',
  '/checkout:children(/?.*)',
  '/community-standards',
  '/confirm-identity',
  '/confirm-identity/address',
  '/confirm-identity/business-bank',
  '/confirm-identity/business-names',
  '/confirm-identity/complete',
  '/confirm-identity/describe-business',
  '/confirm-identity/free-form/:stepId',
  '/confirm-identity/multiple-accounts',
  '/confirm-identity/online-details',
  '/confirm-identity/product-usage',
  '/confirm-identity/ready-to-sell',
  '/confirm-identity/resale-tax-id',
  '/confirm-identity/sign-submit',
  '/confirm-identity/store-photos',
  '/confirm-identity/third-party-exclusivity',
  '/confirm-identity/verification-method',
  '/confirm-local-sso',
  '/copyright',
  '/copyright:children(/?.*)',
  '/credit-report-use',
  '/deactivate/r/:invitationToken',
  '/deactivate/r/:invitationToken/confirm-deactivation',
  '/deactivate/r/:invitationToken/verify-identity',
  '/direct-mail1',
  '/direct/:brandAlias',
  '/direct/:brandAlias/rep/:salesRepCode',
  '/direct/:brandTokenOrAlias/product-based-collection/:productBasedCollectionToken',
  '/direct/:brandTokenOrAlias/product/:productToken([^/]*)',
  '/discover/:searchTerm([^/]*)',
  '/empty',
  '/exclusivity',
  '/exclusivity/all-brands',
  '/expanding-businesses-offer',
  '/expanding-businesses-offer/apply',
  '/expired-link',
  '/explore/:searchTerm([^/]*)',
  '/expo',
  '/extension-secret',
  '/faire-content/:faireContentTokenOrAlias',
  '/faire-event/:faireContentTokenOrAlias',
  '/faire-forecast-2025',
  '/faire-pay',
  '/faire-pay/mobile-pre-enroll',
  '/faire-pay/setup',
  '/faire-webinar/:faireContentTokenOrAlias',
  '/fancy-food',
  '/fbfexhibits',
  '/featured',
  '/featured/wholesale-gifts',
  '/flash-sale',
  '/flash-sale/:flashSaleToken([^/]*)',
  '/forecast',
  '/get-started',
  '/grand-prix',
  '/guaranteedfairtrade',
  '/harrogate',
  '/imprint',
  '/insider',
  '/insider/terms-and-conditions',
  '/insights',
  '/jobs',
  '/lp/:pageName([^/]*)',
  '/m/:pageName([^/]*)',
  '/magic',
  '/magiclv',
  '/maker/:brandToken([^/]*)',
  '/makers',
  '/markets',
  '/markets/all-specials',
  '/markets/all-specials/my-market-list',
  '/markets/brand-directory/:eventType',
  '/markets/specials-a-z',
  '/markets/:eventType',
  '/markets/:eventType/all-specials',
  '/markets/:eventType/all-specials/my-market-list',
  '/markets:children(/?.*)',
  '/merchandised-collection/:mcVanityUrl([^/]*)',
  '/merchandised-collection:children(/?.*)',
  '/merge/:mergeIdentifier',
  '/messages',
  '/messages/:otherPartyToken',
  '/messages:children(/?.*)',
  '/milestones',
  '/my-brands',
  '/my-brands/now-on-faire',
  '/my-brands/now-on-faire/find-brands',
  '/my-brands/updates',
  '/my-reviews',
  '/my-reviews/brand-order/:brandOrderToken',
  '/my-reviews/brand-order/:brandOrderToken/products',
  '/my-reviews/brand-order/:brandOrderToken/products/:productToken',
  '/my-reviews/brand/:brandToken',
  '/my-reviews/completed',
  '/natexpo25',
  '/net-terms',
  '/net-terms/apply',
  '/net-terms/increase-limit',
  '/net-terms/owf-application',
  '/net-terms/success',
  '/net-terms:children(/?.*)',
  '/new-brand-finder',
  '/new-brand-finder/:resultToken',
  '/news',
  '/news/about',
  '/news/case-studies',
  '/news/media',
  '/news/:articleToken([^/]*)',
  '/nextjs-streaming-test',
  '/onboard',
  '/onfirm-identity/third-party-exclusivity',
  '/open',
  '/open-with-faire',
  '/open-with-faire-additional-info',
  '/open-with-faire/academy',
  '/open-with-faire/academy/buy-retail-inventory',
  '/open-with-faire/academy/find-retail-space',
  '/open-with-faire/academy/funding-licensing',
  '/open-with-faire/academy/lay-the-groundwork',
  '/open-with-faire/academy/organize-store-operations',
  '/open-with-faire/academy/promote-your-store',
  '/open-with-faire/academy/renovate-your-store',
  '/open-with-faire:children(/?.*)',
  '/open:children(/?.*)',
  '/order-insights',
  '/order-insights/:resultToken',
  '/orders',
  '/orders/:orderToken/:brandToken',
  '/owf',
  '/owf:children(/?.*)',
  '/partner-collection/:mcVanityUrl([^/]*)',
  '/partnerships',
  '/pgl',
  '/plaid-oauth-result',
  '/point-of-sale',
  '/point-of-sale/about',
  '/point-of-sale/archived',
  '/point-of-sale/connect-clover-app',
  '/point-of-sale/connect-shopify-app',
  '/point-of-sale/connect-square-app',
  '/point-of-sale/consent',
  '/point-of-sale/item/:productOptionToken',
  '/point-of-sale/item/:productOptionToken/edit',
  '/point-of-sale/items',
  '/point-of-sale/linked',
  '/point-of-sale/matches',
  '/point-of-sale/onboarding',
  '/point-of-sale/order-manager/:orderToken',
  '/point-of-sale/orders',
  '/point-of-sale/orders/:brandOrderToken',
  '/point-of-sale/orders/:orderToken/:brandToken',
  '/point-of-sale/settings',
  '/point-of-sale/unlinked',
  '/popular',
  '/press',
  '/prestashop',
  '/privacy',
  '/privacy-disclosure',
  '/privacy-us',
  '/privacy/cookies',
  '/privacy:children(/?.*)',
  '/product-based-collection/:productBasedCollectionToken',
  '/product/:productToken([^/]*)',
  '/product/:productToken([^/]*):children(/?.*)',
  '/product/:productToken/added-to-cart',
  '/recommendation/brands',
  '/recommendation/products',
  '/reject-brand-email-verification/:emailVerificationRequestToken',
  '/reject-brand-idv-request/:idvRequestToken',
  '/reorder',
  '/rep/:salesRepCode',
  '/retailer/pos',
  '/retailer/pos/items',
  '/retailer/pos/items/:productOptionToken',
  '/retailer/pos/matching',
  '/retailer/settings',
  '/retailer/settings/account',
  '/retailer/settings/available-credit',
  '/retailer/settings/deactivate-account',
  '/retailer/settings/email-preferences',
  '/retailer/settings/insider-membership',
  '/retailer/settings/insider-membership/cancellation',
  '/retailer/settings/my-addresses',
  '/retailer/settings/my-team',
  '/retailer/settings/my-team/permissions/:userToken',
  '/retailer/settings/onboard',
  '/retailer/settings/payment-methods',
  '/retailer/settings/pos-manager',
  '/retailer/settings/profile',
  '/retailer/settings/security',
  '/retailer/settings/security/account-activity',
  '/retailer/settings/shipping-preferences',
  '/retailer/settings/stores',
  '/retailer/settings/stores/new',
  '/retailer/settings/stores/:storeToken',
  '/retailer/:retailerToken',
  '/retailer/:retailerToken/brand-order/:brandOrderToken/review',
  '/retailer/:retailerToken/brand/:brandToken([^/]*)',
  '/retailer/:retailerToken/brand/:brandToken([^/]*):children(/?.*)',
  '/retailer/:retailerToken/brand/:brandToken/brand-order/select-for-review',
  '/retailer/:retailerToken/cart',
  '/retailer/:retailerToken/category/:c1Category([^/]*)/subcategory/:c2Category([^/]*)/:c3Category([^/]*)',
  '/retailer/:retailerToken/category/:categoryName([^/]*)',
  '/retailer/:retailerToken/category/:categoryName([^/]*)/subcategory/:subcategoryName([^/]*)',
  '/retailer/:retailerToken/confirm-identity',
  '/retailer/:retailerToken/discover',
  '/retailer/:retailerToken/discover:children(/?.*)',
  '/retailer/:retailerToken/flash-sale',
  '/retailer/:retailerToken/flash-sale/:flashSaleToken([^/]*)',
  '/retailer/:retailerToken/limit',
  '/retailer/:retailerToken/my-brands',
  '/retailer/:retailerToken/net-terms:children(/?.*)',
  '/retailer/:retailerToken/reorder',
  '/retailer/:retailerToken/retailer-product-recommendations',
  '/retailer/:retailerToken/reviews',
  '/retailer/:retailerToken/search',
  '/sample-with-food-and-beverage',
  '/sample/:inviteToken',
  '/sdui-visualizer',
  '/search',
  '/search:children(/?.*)',
  '/see-more',
  '/shop-the-stories',
  '/sign-up/social',
  '/site-map',
  '/sitemap.xml.gz',
  '/sitewide-offer',
  '/small-business-grant',
  '/small-business-grant/apply',
  '/small-business-grant/tos',
  '/spring-fair',
  '/square-home',
  '/square-home:children(/?.*)',
  '/stand-against-bland',
  '/summer-market',
  '/summer-market-2021',
  '/summer-market-2021:children(/?.*)',
  '/summer-market:children(/?.*)',
  '/suppliers/:c1SuppliersUrlId',
  '/suppliers/:c1SuppliersUrlId/brand-value/:brandValue',
  '/suppliers/:c1SuppliersUrlId/subcategory/:c2SuppliersUrlId',
  '/suppliers/:c1SuppliersUrlId/subcategory/:c2SuppliersUrlId/:c3SuppliersUrlId',
  '/team',
  '/tools',
  '/tools/:toolName([^/]*)',
  '/tos',
  '/tos-brand',
  '/tos-brand-july5',
  '/tos-faire-pay',
  '/tos-insider',
  '/tos-product-guidelines',
  '/tos-purchase-order',
  '/tos-reacceptance',
  '/tos-retailer',
  '/tos-returns-guidelines',
  '/tos_maker',
  '/tos:children(/?.*)',
  '/trending-on-faire',
  '/trendset',
  '/underwriting-information',
  '/unrecognized-login-notification',
  '/unsubscribe',
  '/unsubscribe-from-brand',
  '/user',
  '/user/account',
  '/user/account/invoices',
  '/user/account/invoices/paid',
  '/user/account/invoices/payment-plan',
  '/user/account/invoices/unpaid',
  '/user/account/invoices/:invoiceToken([^/]*)',
  '/user/account/new-payment-plan',
  '/user/account/orders',
  '/user/account/orders/brandInvoices/:brandInvoiceToken',
  '/user/account/orders/completed',
  '/user/account/orders/pending',
  '/user/account/orders/purchase-orders/create',
  '/user/account/orders/purchase-orders/create/:purchaseOrderToken',
  '/user/account/orders/purchase-orders/landing-page',
  '/user/account/orders/purchase-orders/:purchaseOrderToken/success',
  '/user/account/orders/purchase_order/:purchaseOrderToken',
  '/user/account/orders/:orderToken([^/]*)/:brandToken([^/]*)',
  '/user/account/orders/:orderToken/:brandOrderToken/return-history',
  '/user/account/orders/:orderToken/:brandToken/report',
  '/user/account/orders/:orderToken/:brandToken/return',
  '/user/account/orders:children(/?.*)',
  '/user/account/payment-assistance',
  '/user/account/payment-plan',
  '/user/account/returns/:returnOrderToken',
  '/user/account/samples/:sampleRequestToken',
  '/user/brand-referrals',
  '/user/brand-referrals/preview-referral-email',
  '/user/brand-referrals:children(/?.*)',
  '/user/edit-order/:brandOrderToken',
  '/user/edit-order/:brandOrderToken/success',
  '/user/insider/cancel',
  '/user/insider/info',
  '/user/insider/pause',
  '/user/insider/success',
  '/user/link-pos/:orderToken/success',
  '/user/maker-referrals',
  '/user/maker-referrals/preview-referral-email',
  '/user/maker-referrals:children(/?.*)',
  '/user/mobile-account-page',
  '/user/notifications',
  '/user/payment-assistance-application',
  '/user/retailer-referrals',
  '/user/sign-up',
  '/user/style-quiz',
  '/user/trade-show-sign-up/:brandInvoiceToken',
  '/user:children(/?.*)',
  '/video/:videoToken([^/]*)',
  '/volume-pricing',
  '/welcome',
  '/welcome/b/personal',
  '/welcome/r',
  '/welcome/r/annual-sales',
  '/welcome/r/book-a-call',
  '/welcome/r/brand-relationship-survey',
  '/welcome/r/business-type',
  '/welcome/r/business-use',
  '/welcome/r/calculate-term-limit',
  '/welcome/r/collect-brands',
  '/welcome/r/combined-open-with-faire/account',
  '/welcome/r/combined-open-with-faire/application',
  '/welcome/r/combined-open-with-faire/ineligible',
  '/welcome/r/combined-open-with-faire/start-shopping',
  '/welcome/r/complete',
  '/welcome/r/connect-email',
  '/welcome/r/consumer',
  '/welcome/r/describe-store',
  '/welcome/r/legal-business-name',
  '/welcome/r/net-term-start-shopping',
  '/welcome/r/net-term-unlocked',
  '/welcome/r/net-terms',
  '/welcome/r/notify-me',
  '/welcome/r/notify-me/success',
  '/welcome/r/open-with-faire/application',
  '/welcome/r/open-with-faire/intro',
  '/welcome/r/open-with-faire/non-bm',
  '/welcome/r/open-with-faire/start-shopping',
  '/welcome/r/open-with-faire/success',
  '/welcome/r/opening-month',
  '/welcome/r/opening-year',
  '/welcome/r/personal',
  '/welcome/r/physical-store-number',
  '/welcome/r/resale-identification',
  '/welcome/r/reseller-cert',
  '/welcome/r/scc-details',
  '/welcome/r/scc-payment-terms',
  '/welcome/r/scc-terms-agreement',
  '/welcome/r/select-categories',
  '/welcome/r/select-payment-terms',
  '/welcome/r/select-products',
  '/welcome/r/social-media',
  '/welcome/r/store-attribution',
  '/welcome/r/store-details',
  '/welcome/r/store-info',
  '/welcome/r/store-type-s1',
  '/welcome/r/store-type-s2',
  '/welcome/r/store-values',
  '/welcome/r/success',
  '/welcome/r/type',
  '/welcome:children(/?.*)',
  '/whats-next',
  '/winter-market-2021',
  '/winter-market-2021:children(/?.*)',
  '/year-in-review',
];

export const retailerRoutesProductArea = {
  '/': 'HOME_FEED',
  '/NEWYEAR25': 'LOGGED_OUT_RETAILERS',
  '/about': 'LOGGED_OUT_RETAILERS',
  '/adyen-linking-action-result': 'ADYEN',
  '/affiliates': 'LOGGED_OUT_RETAILERS',
  '/all-brands': 'SEO',
  '/all-makers': 'SEO',
  '/amex': 'AMEX',
  '/aoda': 'TERMS_OF_SERVICE',
  '/apparel-collection/:productBasedCollectionToken([^/]+)':
    'APPAREL_COLLECTIONS',
  '/apply': 'BRAND_ACQUISITION',
  '/apply/ad': 'BRAND_ACQUISITION',
  '/apply/markets': 'BRAND_ACQUISITION',
  '/apply/r/:retailerTokenSuffix': 'BRAND_ACQUISITION',
  '/apply/:brandTokenOrAlias': 'BRAND_ACQUISITION',
  '/apply:children(/?.*)': 'BRAND_ACQUISITION',
  '/assortment/:assortmentToken': 'AI_TOOLS',
  '/atl': 'LOGGED_OUT_RETAILERS',
  '/atlanta-market': 'LOGGED_OUT_RETAILERS',
  '/atlantamarket': 'LOGGED_OUT_RETAILERS',
  '/autumn-fair': 'LOGGED_OUT_RETAILERS',
  '/bestseller': 'LOGGED_OUT_RETAILERS',
  '/blog': 'LOGGED_OUT_RETAILERS',
  '/blog/:category([^/]*)': 'LOGGED_OUT_RETAILERS',
  '/blog/:category([^/]*)/:article([^/]*)': 'LOGGED_OUT_RETAILERS',
  '/boards': 'BOARDS',
  '/boards/following': 'BOARDS',
  '/boards/:retailerBoardToken': 'BOARDS',
  '/boards:children(/?.*)': 'BOARDS',
  '/brand-invoice/:brandInvoiceToken([^/]*)': 'BRAND_ONBOARDING',
  '/brand-order/:brandOrderToken': 'BRAND_ORDERS',
  '/brand-order/:brandOrderToken/duties-refund': 'DUTIES',
  '/brand-order/:brandOrderToken/duties-refund/further-review': 'DUTIES',
  '/brand-order/:brandOrderToken/duties-refund/success': 'DUTIES',
  '/brand-order/:brandOrderToken/:children(/?.*)': 'BRAND_ORDERS',
  '/brand/:brandToken([^/]*)': 'BRAND_PAGE',
  '/brand/:brandToken([^/]*)/:page(\d+)': 'BRAND_PAGE',
  '/brand/:brandToken([^/]*):children(/?.*)': 'BRAND_CORE',
  '/brand/:brandToken/brand-order/select-for-review': 'BRAND_REVIEWS',
  '/brand/:brandToken/buy-it-again': 'BUY_IT_AGAIN',
  '/brand/:brandToken/new-products': 'PRODUCTS',
  '/brand/:brandToken/product-bundle/:bundleIdentifier': 'PRODUCT_BUNDLES',
  '/brand/:brandToken/videos': 'VIDEOS',
  '/brands': 'BRAND_ACQUISITION',
  '/brands/app': 'BRAND_MOBILE',
  '/brands/category': 'BRAND_ACQUISITION',
  '/brands/create-account': 'BRAND_ACQUISITION',
  '/brands/direct': 'BRAND_ACQUISITION',
  '/brands/fwm': 'BRAND_ACQUISITION',
  '/brands/non-fwm': 'BRAND_ACQUISITION',
  '/brands/personalized': 'BRAND_ACQUISITION',
  '/brands/pricing': 'BRAND_ACQUISITION',
  '/brands/referral-offer/:brandLeadReferralBonusOfferToken':
    'BRAND_ACQUISITION',
  '/brands/referral/:brandLeadReferralToken': 'BRAND_ACQUISITION',
  '/brands/:brandToken': 'BRAND_ACQUISITION',
  '/builder': 'LOGGED_OUT_RETAILERS',
  '/builder-testing': 'LOGGED_OUT_RETAILERS',
  '/builder/edit-symbols': 'LOGGED_OUT_RETAILERS',
  '/builder/:pageName([^/]*)': 'LOGGED_OUT_RETAILERS',
  '/careers': 'LOGGED_OUT_RETAILERS',
  '/careers/belonging-at-faire': 'LOGGED_OUT_RETAILERS',
  '/careers/flexible-work-policy': 'LOGGED_OUT_RETAILERS',
  '/careers/openings': 'LOGGED_OUT_RETAILERS',
  '/cares-act': 'LOGGED_OUT_RETAILERS',
  '/cart': 'CART',
  '/cart/:brandToken([^/]*)': 'CART',
  '/category/Drops': 'CATEGORY_RESULTS',
  '/category/Showroom': 'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId': 'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/attribute/:attributeName/:attributeValue':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/brand-value/:brandValue': 'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/loc/:country/:region': 'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId': 'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/attribute/:attributeName/:attributeValue':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/brand-value/:brandValue':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/loc/:country/:region':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/attribute/:attributeName/:attributeValue':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/brand-value/:brandValue':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/loc/:country/:region':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId/:c5CategoryUrlId':
    'CATEGORY_RESULTS',
  '/category/:c1CategoryUrlId/subcategory/:c2CategoryUrlId/:c3CategoryUrlId/:c4CategoryUrlId/:c5CategoryUrlId/:c6CategoryUrlId':
    'CATEGORY_RESULTS',
  '/checkout': 'CHECKOUT',
  '/checkout/business-info': 'CHECKOUT',
  '/checkout/payment-info': 'CHECKOUT',
  '/checkout/payment-terms': 'CHECKOUT',
  '/checkout/select-payment': 'CHECKOUT',
  '/checkout/shipping-address': 'CHECKOUT',
  '/checkout/shipping-address/new': 'CHECKOUT',
  '/checkout/shipping-methods': 'CHECKOUT',
  '/checkout/signup': 'CHECKOUT',
  '/checkout/success/:orderToken': 'CHECKOUT',
  '/checkout/verification/:orderToken': 'CHECKOUT',
  '/checkout:children(/?.*)': 'CHECKOUT',
  '/community-standards': 'HELP_CENTER',
  '/confirm-identity': 'IDV',
  '/confirm-identity/address': 'IDV',
  '/confirm-identity/business-bank': 'IDV',
  '/confirm-identity/business-names': 'IDV',
  '/confirm-identity/complete': 'IDV',
  '/confirm-identity/describe-business': 'IDV',
  '/confirm-identity/free-form/:stepId': 'IDV',
  '/confirm-identity/multiple-accounts': 'IDV',
  '/confirm-identity/online-details': 'IDV',
  '/confirm-identity/product-usage': 'IDV',
  '/confirm-identity/ready-to-sell': 'IDV',
  '/confirm-identity/resale-tax-id': 'IDV',
  '/confirm-identity/sign-submit': 'IDV',
  '/confirm-identity/store-photos': 'IDV',
  '/confirm-identity/third-party-exclusivity': 'IDV',
  '/confirm-identity/verification-method': 'IDV',
  '/confirm-local-sso': 'AUTH',
  '/copyright': 'TERMS_OF_SERVICE',
  '/copyright:children(/?.*)': 'TERMS_OF_SERVICE',
  '/credit-report-use': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/deactivate/r/:invitationToken': 'SIGNUP_FLOW',
  '/deactivate/r/:invitationToken/confirm-deactivation': 'SIGNUP_FLOW',
  '/deactivate/r/:invitationToken/verify-identity': 'SIGNUP_FLOW',
  '/direct-mail1': 'LOGGED_OUT_RETAILERS',
  '/direct/:brandAlias': 'HOME_FEED',
  '/direct/:brandAlias/rep/:salesRepCode': 'HOME_FEED',
  '/direct/:brandTokenOrAlias/product-based-collection/:productBasedCollectionToken':
    'CORE_COLLECTIONS',
  '/direct/:brandTokenOrAlias/product/:productToken([^/]*)': 'PRODUCT_PAGE',
  '/discover/:searchTerm([^/]*)': 'SEO',
  '/empty': 'WEB_SERVER_SIDE_RENDERING',
  '/exclusivity': 'EXCLUSIVITY',
  '/exclusivity/all-brands': 'EXCLUSIVITY',
  '/expanding-businesses-offer': 'OPEN_WITH_FAIRE',
  '/expanding-businesses-offer/apply': 'OPEN_WITH_FAIRE',
  '/expired-link': 'SECURITY',
  '/explore/:searchTerm([^/]*)': 'SEO',
  '/expo': 'LOGGED_OUT_RETAILERS',
  '/extension-secret': 'AUTH',
  '/faire-content/:faireContentTokenOrAlias': 'FAIRE_CONTENT',
  '/faire-event/:faireContentTokenOrAlias': 'FAIRE_CONTENT',
  '/faire-forecast-2025': 'LOGGED_OUT_RETAILERS',
  '/faire-pay': 'PAYMENTS',
  '/faire-pay/mobile-pre-enroll': 'PAYMENTS',
  '/faire-pay/setup': 'PAYMENTS',
  '/faire-webinar/:faireContentTokenOrAlias': 'FAIRE_CONTENT',
  '/fancy-food': 'LOGGED_OUT_RETAILERS',
  '/fbfexhibits': 'FULFILLED_BY_FAIRE',
  '/featured': 'SEO',
  '/featured/wholesale-gifts': 'SEO',
  '/flash-sale': 'FLASH_SALES',
  '/flash-sale/:flashSaleToken([^/]*)': 'FLASH_SALES',
  '/forecast': 'LOGGED_OUT_RETAILERS',
  '/get-started': 'LOGGED_OUT_RETAILERS',
  '/grand-prix': 'LOGGED_OUT_RETAILERS',
  '/guaranteedfairtrade': 'CATEGORY_RESULTS',
  '/harrogate': 'LOGGED_OUT_RETAILERS',
  '/imprint': 'LOGGED_OUT_RETAILERS',
  '/insider': 'INSIDER',
  '/insider/terms-and-conditions': 'INSIDER',
  '/insights': 'AI_TOOLS',
  '/jobs': 'LOGGED_OUT_RETAILERS',
  '/lp/:pageName([^/]*)': 'LOGGED_OUT_RETAILERS',
  '/m/:pageName([^/]*)': 'LOGGED_OUT_RETAILERS',
  '/magic': 'LOGGED_OUT_RETAILERS',
  '/magiclv': 'LOGGED_OUT_RETAILERS',
  '/maker/:brandToken([^/]*)': 'BRAND_CORE',
  '/makers': 'BRAND_ACQUISITION',
  '/markets': 'LOGGED_IN_HOMEPAGE',
  '/markets/all-specials': 'LOGGED_IN_HOMEPAGE',
  '/markets/all-specials/my-market-list': 'LOGGED_IN_HOMEPAGE',
  '/markets/brand-directory/:eventType': 'LOGGED_IN_HOMEPAGE',
  '/markets/specials-a-z': 'LOGGED_IN_HOMEPAGE',
  '/markets/:eventType': 'LOGGED_IN_HOMEPAGE',
  '/markets/:eventType/all-specials': 'LOGGED_IN_HOMEPAGE',
  '/markets/:eventType/all-specials/my-market-list': 'LOGGED_IN_HOMEPAGE',
  '/markets:children(/?.*)': 'LOGGED_IN_HOMEPAGE',
  '/merchandised-collection/:mcVanityUrl([^/]*)': 'COLLECTIONS',
  '/merchandised-collection:children(/?.*)': 'COLLECTIONS',
  '/merge/:mergeIdentifier': 'MULTI_BRAND',
  '/messages': 'RETAILER_MESSENGER',
  '/messages/:otherPartyToken': 'RETAILER_MESSENGER',
  '/messages:children(/?.*)': 'RETAILER_MESSENGER',
  '/milestones': 'LOGGED_OUT_RETAILERS',
  '/my-brands': 'RETAILER_BRANDS_MANAGEMENT',
  '/my-brands/now-on-faire': 'RETAILER_BRANDS_MANAGEMENT',
  '/my-brands/now-on-faire/find-brands': 'RETAILER_BRANDS_MANAGEMENT',
  '/my-brands/updates': 'RETAILER_BRANDS_MANAGEMENT',
  '/my-reviews': 'BRAND_REVIEWS',
  '/my-reviews/brand-order/:brandOrderToken': 'BRAND_REVIEWS',
  '/my-reviews/brand-order/:brandOrderToken/products': 'BRAND_REVIEWS',
  '/my-reviews/brand-order/:brandOrderToken/products/:productToken':
    'BRAND_REVIEWS',
  '/my-reviews/brand/:brandToken': 'BRAND_REVIEWS',
  '/my-reviews/completed': 'BRAND_REVIEWS',
  '/natexpo25': 'LOGGED_OUT_RETAILERS',
  '/net-terms': 'NET_TERMS',
  '/net-terms/apply': 'NET_TERMS',
  '/net-terms/increase-limit': 'NET_TERMS',
  '/net-terms/owf-application': 'NET_TERMS',
  '/net-terms/success': 'NET_TERMS',
  '/net-terms:children(/?.*)': 'NET_TERMS',
  '/new-brand-finder': 'AI_TOOLS',
  '/new-brand-finder/:resultToken': 'AI_TOOLS',
  '/news': 'LOGGED_OUT_RETAILERS',
  '/news/about': 'LOGGED_OUT_RETAILERS',
  '/news/case-studies': 'LOGGED_OUT_RETAILERS',
  '/news/media': 'LOGGED_OUT_RETAILERS',
  '/news/:articleToken([^/]*)': 'LOGGED_OUT_RETAILERS',
  '/nextjs-streaming-test': 'WEB_RETAILER_SERVER',
  '/onboard': 'IDV',
  '/onfirm-identity/third-party-exclusivity': 'IDV',
  '/open': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire-additional-info': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy/buy-retail-inventory': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy/find-retail-space': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy/funding-licensing': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy/lay-the-groundwork': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy/organize-store-operations':
    'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy/promote-your-store': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire/academy/renovate-your-store': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open-with-faire:children(/?.*)': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/open:children(/?.*)': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/order-insights': 'AI_TOOLS',
  '/order-insights/:resultToken': 'AI_TOOLS',
  '/orders': 'RETAILER_ORDER_MANAGEMENT',
  '/orders/:orderToken/:brandToken': 'RETAILER_ORDER_MANAGEMENT',
  '/owf': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/owf:children(/?.*)': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/partner-collection/:mcVanityUrl([^/]*)': 'COLLECTIONS',
  '/partnerships': 'LOGGED_OUT_RETAILERS',
  '/pgl': 'LOGGED_OUT_RETAILERS',
  '/plaid-oauth-result': 'PLAID',
  '/point-of-sale': 'FAIRESYNC',
  '/point-of-sale/about': 'FAIRESYNC',
  '/point-of-sale/archived': 'FAIRESYNC',
  '/point-of-sale/connect-clover-app': 'FAIRESYNC',
  '/point-of-sale/connect-shopify-app': 'FAIRESYNC',
  '/point-of-sale/connect-square-app': 'FAIRESYNC',
  '/point-of-sale/consent': 'FAIRESYNC',
  '/point-of-sale/item/:productOptionToken': 'FAIRESYNC',
  '/point-of-sale/item/:productOptionToken/edit': 'FAIRESYNC',
  '/point-of-sale/items': 'FAIRESYNC',
  '/point-of-sale/linked': 'FAIRESYNC',
  '/point-of-sale/matches': 'FAIRESYNC',
  '/point-of-sale/onboarding': 'FAIRESYNC',
  '/point-of-sale/order-manager/:orderToken': 'FAIRESYNC',
  '/point-of-sale/orders': 'FAIRESYNC',
  '/point-of-sale/orders/:brandOrderToken': 'FAIRESYNC',
  '/point-of-sale/orders/:orderToken/:brandToken': 'FAIRESYNC',
  '/point-of-sale/settings': 'FAIRESYNC',
  '/point-of-sale/unlinked': 'FAIRESYNC',
  '/popular': 'SEO',
  '/press': 'LOGGED_OUT_RETAILERS',
  '/prestashop': 'PRESTASHOP',
  '/privacy': 'PRIVACY',
  '/privacy-disclosure': 'PRIVACY',
  '/privacy-us': 'PRIVACY',
  '/privacy/cookies': 'PRIVACY',
  '/privacy:children(/?.*)': 'PRIVACY',
  '/product-based-collection/:productBasedCollectionToken': 'CORE_COLLECTIONS',
  '/product/:productToken([^/]*)': 'PRODUCT_PAGE',
  '/product/:productToken([^/]*):children(/?.*)': 'PRODUCT_PAGE',
  '/product/:productToken/added-to-cart': 'PRODUCT_PAGE',
  '/recommendation/brands': 'LOGGED_OUT_RETAILERS',
  '/recommendation/products': 'LOGGED_OUT_RETAILERS',
  '/reject-brand-email-verification/:emailVerificationRequestToken':
    'BRAND_VERIFICATION',
  '/reject-brand-idv-request/:idvRequestToken': 'BRAND_VERIFICATION',
  '/reorder': 'RETAILER_BRANDS_MANAGEMENT',
  '/rep/:salesRepCode': 'SALES_REPS',
  '/retailer/pos': 'FAIRESYNC',
  '/retailer/pos/items': 'FAIRESYNC',
  '/retailer/pos/items/:productOptionToken': 'FAIRESYNC',
  '/retailer/pos/matching': 'FAIRESYNC',
  '/retailer/settings': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/account': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/available-credit': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/deactivate-account': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/email-preferences': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/insider-membership': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/insider-membership/cancellation':
    'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/my-addresses': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/my-team': 'RETAILER_TEAM_MANAGEMENT',
  '/retailer/settings/my-team/permissions/:userToken':
    'RETAILER_TEAM_MANAGEMENT',
  '/retailer/settings/onboard': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/payment-methods': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/pos-manager': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/profile': 'RETAILER_SETTINGS_PAGE',
  '/retailer/settings/security': 'SECURITY',
  '/retailer/settings/security/account-activity': 'SECURITY',
  '/retailer/settings/shipping-preferences': 'SHIPPING',
  '/retailer/settings/stores': 'RETAILER_STORE_MANAGEMENT',
  '/retailer/settings/stores/new': 'RETAILER_STORE_MANAGEMENT',
  '/retailer/settings/stores/:storeToken': 'RETAILER_STORE_MANAGEMENT',
  '/retailer/:retailerToken': 'IDV',
  '/retailer/:retailerToken/brand-order/:brandOrderToken/review':
    'BRAND_REVIEWS',
  '/retailer/:retailerToken/brand/:brandToken([^/]*)':
    'RETAILER_BRANDS_MANAGEMENT',
  '/retailer/:retailerToken/brand/:brandToken([^/]*):children(/?.*)':
    'RETAILER_BRANDS_MANAGEMENT',
  '/retailer/:retailerToken/brand/:brandToken/brand-order/select-for-review':
    'BRAND_REVIEWS',
  '/retailer/:retailerToken/cart': 'CART',
  '/retailer/:retailerToken/category/:c1Category([^/]*)/subcategory/:c2Category([^/]*)/:c3Category([^/]*)':
    'CATEGORY_RESULTS',
  '/retailer/:retailerToken/category/:categoryName([^/]*)': 'CATEGORY_RESULTS',
  '/retailer/:retailerToken/category/:categoryName([^/]*)/subcategory/:subcategoryName([^/]*)':
    'CATEGORY_RESULTS',
  '/retailer/:retailerToken/confirm-identity': 'IDV',
  '/retailer/:retailerToken/discover': 'SEO',
  '/retailer/:retailerToken/discover:children(/?.*)': 'SEO',
  '/retailer/:retailerToken/flash-sale': 'FLASH_SALES',
  '/retailer/:retailerToken/flash-sale/:flashSaleToken([^/]*)': 'FLASH_SALES',
  '/retailer/:retailerToken/limit': 'NET_TERMS',
  '/retailer/:retailerToken/my-brands': 'RETAILER_BRANDS_MANAGEMENT',
  '/retailer/:retailerToken/net-terms:children(/?.*)': 'NET_TERMS',
  '/retailer/:retailerToken/reorder': 'RETAILER_BRANDS_MANAGEMENT',
  '/retailer/:retailerToken/retailer-product-recommendations': 'IDV',
  '/retailer/:retailerToken/reviews': 'BRAND_REVIEWS',
  '/retailer/:retailerToken/search': 'SEARCH',
  '/sample-with-food-and-beverage': 'SAMPLES',
  '/sample/:inviteToken': 'SAMPLES',
  '/sdui-visualizer': 'SDUI',
  '/search': 'SEARCH',
  '/search:children(/?.*)': 'SEARCH',
  '/see-more': 'NAVIGATION_INFRASTRUCTURE',
  '/shop-the-stories': 'RETAILER_ONBOARDING',
  '/sign-up/social': 'SIGNUP_FLOW',
  '/site-map': 'SEO',
  '/sitemap.xml.gz': 'SEO',
  '/sitewide-offer': 'GROW_WITH_FAIRE',
  '/small-business-grant': 'LOGGED_OUT_RETAILERS',
  '/small-business-grant/apply': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/small-business-grant/tos': 'OPEN_WITH_FAIRE_LOGGED_OUT',
  '/spring-fair': 'LOGGED_OUT_RETAILERS',
  '/square-home': 'FAIRESYNC_INTEGRATION_SQUARE',
  '/square-home:children(/?.*)': 'FAIRESYNC_INTEGRATION_SQUARE',
  '/stand-against-bland': 'LOGGED_OUT_RETAILERS',
  '/summer-market': 'LOGGED_IN_HOMEPAGE',
  '/summer-market-2021': 'LOGGED_IN_HOMEPAGE',
  '/summer-market-2021:children(/?.*)': 'LOGGED_IN_HOMEPAGE',
  '/summer-market:children(/?.*)': 'LOGGED_IN_HOMEPAGE',
  '/suppliers/:c1SuppliersUrlId': 'SEO',
  '/suppliers/:c1SuppliersUrlId/brand-value/:brandValue': 'SEO',
  '/suppliers/:c1SuppliersUrlId/subcategory/:c2SuppliersUrlId': 'SEO',
  '/suppliers/:c1SuppliersUrlId/subcategory/:c2SuppliersUrlId/:c3SuppliersUrlId':
    'SEO',
  '/team': 'LOGGED_OUT_RETAILERS',
  '/tools': 'LOGGED_OUT_RETAILERS',
  '/tools/:toolName([^/]*)': 'LOGGED_OUT_RETAILERS',
  '/tos': 'TERMS_OF_SERVICE',
  '/tos-brand': 'TERMS_OF_SERVICE',
  '/tos-brand-july5': 'TERMS_OF_SERVICE',
  '/tos-faire-pay': 'TERMS_OF_SERVICE',
  '/tos-insider': 'TERMS_OF_SERVICE',
  '/tos-product-guidelines': 'TERMS_OF_SERVICE',
  '/tos-purchase-order': 'TERMS_OF_SERVICE',
  '/tos-reacceptance': 'IDV',
  '/tos-retailer': 'TERMS_OF_SERVICE',
  '/tos-returns-guidelines': 'TERMS_OF_SERVICE',
  '/tos_maker': 'TERMS_OF_SERVICE',
  '/tos:children(/?.*)': 'TERMS_OF_SERVICE',
  '/trending-on-faire': 'SEO',
  '/trendset': 'LOGGED_OUT_RETAILERS',
  '/underwriting-information': 'IDV',
  '/unrecognized-login-notification': 'LOGGED_OUT_RETAILERS',
  '/unsubscribe': 'EMAIL_INFRA',
  '/unsubscribe-from-brand': 'EMAIL_INFRA',
  '/user': 'RETAILER_ACCOUNT_MANAGEMENT',
  '/user/account': 'RETAILER_ACCOUNT_MANAGEMENT',
  '/user/account/invoices': 'PAYMENTS',
  '/user/account/invoices/paid': 'PAYMENTS',
  '/user/account/invoices/payment-plan': 'PAYMENTS',
  '/user/account/invoices/unpaid': 'PAYMENTS',
  '/user/account/invoices/:invoiceToken([^/]*)': 'PAYMENTS',
  '/user/account/new-payment-plan': 'PAYMENTS',
  '/user/account/orders': 'RETAILER_ORDER_MANAGEMENT',
  '/user/account/orders/brandInvoices/:brandInvoiceToken': 'BRAND_INVOICES',
  '/user/account/orders/completed': 'RETAILER_ORDER_MANAGEMENT',
  '/user/account/orders/pending': 'RETAILER_ORDER_MANAGEMENT',
  '/user/account/orders/purchase-orders/create': 'PURCHASE_ORDER_INGESTION',
  '/user/account/orders/purchase-orders/create/:purchaseOrderToken':
    'PURCHASE_ORDER_INGESTION',
  '/user/account/orders/purchase-orders/landing-page':
    'PURCHASE_ORDER_INGESTION',
  '/user/account/orders/purchase-orders/:purchaseOrderToken/success':
    'PURCHASE_ORDER_INGESTION',
  '/user/account/orders/purchase_order/:purchaseOrderToken':
    'PURCHASE_ORDER_INGESTION',
  '/user/account/orders/:orderToken([^/]*)/:brandToken([^/]*)':
    'RETAILER_ORDER_MANAGEMENT',
  '/user/account/orders/:orderToken/:brandOrderToken/return-history': 'RETURNS',
  '/user/account/orders/:orderToken/:brandToken/report':
    'RETAILER_ORDER_MANAGEMENT',
  '/user/account/orders/:orderToken/:brandToken/return': 'RETURNS',
  '/user/account/orders:children(/?.*)': 'RETAILER_ORDER_MANAGEMENT',
  '/user/account/payment-assistance': 'PAYMENTS',
  '/user/account/payment-plan': 'PAYMENTS',
  '/user/account/returns/:returnOrderToken': 'RETURNS',
  '/user/account/samples/:sampleRequestToken': 'SAMPLES_RETAILER',
  '/user/brand-referrals': 'B2B_REFERRALS',
  '/user/brand-referrals/preview-referral-email': 'B2B_REFERRALS',
  '/user/brand-referrals:children(/?.*)': 'B2B_REFERRALS',
  '/user/edit-order/:brandOrderToken': 'RETAILER_ORDER_MANAGEMENT',
  '/user/edit-order/:brandOrderToken/success': 'RETAILER_ORDER_MANAGEMENT',
  '/user/insider/cancel': 'INSIDER',
  '/user/insider/info': 'INSIDER',
  '/user/insider/pause': 'INSIDER',
  '/user/insider/success': 'INSIDER',
  '/user/link-pos/:orderToken/success': 'RETAILER_POS_INTEGRATIONS',
  '/user/maker-referrals': 'B2B_REFERRALS',
  '/user/maker-referrals/preview-referral-email': 'B2B_REFERRALS',
  '/user/maker-referrals:children(/?.*)': 'B2B_REFERRALS',
  '/user/mobile-account-page': 'RETAILER_MOBILE',
  '/user/notifications': 'RETAILER_NOTIFICATIONS',
  '/user/payment-assistance-application': 'PAYMENTS',
  '/user/retailer-referrals': 'R2R_REFERRALS',
  '/user/sign-up': 'RETAILER_ONBOARDING',
  '/user/style-quiz': 'RETAILER_ONBOARDING',
  '/user/trade-show-sign-up/:brandInvoiceToken': 'TRADESHOW',
  '/user:children(/?.*)': 'RETAILER_ACCOUNT_MANAGEMENT',
  '/video/:videoToken([^/]*)': 'BRANDS',
  '/volume-pricing': 'INSIDER',
  '/welcome': 'SIGNUP_FLOW',
  '/welcome/b/personal': 'SIGNUP_FLOW',
  '/welcome/r': 'SIGNUP_FLOW',
  '/welcome/r/annual-sales': 'SIGNUP_FLOW',
  '/welcome/r/book-a-call': 'SIGNUP_FLOW',
  '/welcome/r/brand-relationship-survey': 'SIGNUP_FLOW',
  '/welcome/r/business-type': 'SIGNUP_FLOW',
  '/welcome/r/business-use': 'SIGNUP_FLOW',
  '/welcome/r/calculate-term-limit': 'SIGNUP_FLOW',
  '/welcome/r/collect-brands': 'SIGNUP_FLOW',
  '/welcome/r/combined-open-with-faire/account': 'SIGNUP_FLOW',
  '/welcome/r/combined-open-with-faire/application': 'SIGNUP_FLOW',
  '/welcome/r/combined-open-with-faire/ineligible': 'SIGNUP_FLOW',
  '/welcome/r/combined-open-with-faire/start-shopping': 'SIGNUP_FLOW',
  '/welcome/r/complete': 'SIGNUP_FLOW',
  '/welcome/r/connect-email': 'SIGNUP_FLOW',
  '/welcome/r/consumer': 'SIGNUP_FLOW',
  '/welcome/r/describe-store': 'SIGNUP_FLOW',
  '/welcome/r/legal-business-name': 'SIGNUP_FLOW',
  '/welcome/r/net-term-start-shopping': 'SIGNUP_FLOW',
  '/welcome/r/net-term-unlocked': 'SIGNUP_FLOW',
  '/welcome/r/net-terms': 'SIGNUP_FLOW',
  '/welcome/r/notify-me': 'SIGNUP_FLOW',
  '/welcome/r/notify-me/success': 'SIGNUP_FLOW',
  '/welcome/r/open-with-faire/application': 'SIGNUP_FLOW',
  '/welcome/r/open-with-faire/intro': 'SIGNUP_FLOW',
  '/welcome/r/open-with-faire/non-bm': 'SIGNUP_FLOW',
  '/welcome/r/open-with-faire/start-shopping': 'SIGNUP_FLOW',
  '/welcome/r/open-with-faire/success': 'SIGNUP_FLOW',
  '/welcome/r/opening-month': 'SIGNUP_FLOW',
  '/welcome/r/opening-year': 'SIGNUP_FLOW',
  '/welcome/r/personal': 'SIGNUP_FLOW',
  '/welcome/r/physical-store-number': 'SIGNUP_FLOW',
  '/welcome/r/resale-identification': 'SIGNUP_FLOW',
  '/welcome/r/reseller-cert': 'SIGNUP_FLOW',
  '/welcome/r/scc-details': 'SIGNUP_FLOW',
  '/welcome/r/scc-payment-terms': 'SIGNUP_FLOW',
  '/welcome/r/scc-terms-agreement': 'SIGNUP_FLOW',
  '/welcome/r/select-categories': 'SIGNUP_FLOW',
  '/welcome/r/select-payment-terms': 'SIGNUP_FLOW',
  '/welcome/r/select-products': 'SIGNUP_FLOW',
  '/welcome/r/social-media': 'SIGNUP_FLOW',
  '/welcome/r/store-attribution': 'SIGNUP_FLOW',
  '/welcome/r/store-details': 'SIGNUP_FLOW',
  '/welcome/r/store-info': 'SIGNUP_FLOW',
  '/welcome/r/store-type-s1': 'SIGNUP_FLOW',
  '/welcome/r/store-type-s2': 'SIGNUP_FLOW',
  '/welcome/r/store-values': 'SIGNUP_FLOW',
  '/welcome/r/success': 'SIGNUP_FLOW',
  '/welcome/r/type': 'SIGNUP_FLOW',
  '/welcome:children(/?.*)': 'SIGNUP_FLOW',
  '/whats-next': 'LOGGED_OUT_RETAILERS',
  '/winter-market-2021': 'LOGGED_IN_HOMEPAGE',
  '/winter-market-2021:children(/?.*)': 'LOGGED_IN_HOMEPAGE',
  '/year-in-review': 'RETAILER_YEAR_IN_REVIEW',
} as const;
